import PropTypes from 'prop-types';
import { isDevEnvironment } from '../../../utilities/env';

const propTypes = {
  /** Animation path */
  src: PropTypes.string,
  /** Object with the exported animation data. Use this when file is hosted locally */
  animationData: PropTypes.object,
  /** If the animation should loop or not */
  loop: PropTypes.bool,
  /** Play the animation as soon it is ready */
  autoplay: PropTypes.bool,
  /** Animation name for future reference */
  name: PropTypes.string,
  /** Called when the animation finishes loading */
  onLoad: PropTypes.func,
  /** Aria label to improve accessibility */
  label: PropTypes.string
};

const defaultProps = {
  src: null,
  animationData: null,
  loop: true,
  autoplay: true,
  name: null,
  onLoad: null,
  label: null,
  width: '300px',
  height: '300px'
};

const Animation = ({ src, animationData, width, height }) => {
  const Tag = isDevEnvironment ? "dotlottie-wc" : "lottie-player";

  return (
    <Tag
      src={src}
      animationData={animationData}
      style={{ width, height }}
      speed="1"
      mode="forward"
      loop
      autoplay
      data-testid="lottie-animation"
    />
  );
};

Animation.defaultProps = defaultProps;

Animation.propTypes = propTypes;

export default Animation;
